import { SCAPaymentEvent } from "../../enums/sca-payment-event";
import { ApiParameters } from "./api-parameters";
import { ApiPostRequest } from "./api-post-request";

export class SCAPaymentEventRequest extends ApiPostRequest
{
    public constructor(orderId: number, event: SCAPaymentEvent, webapiBasepath: string)
    {
        super(  'scapaymentevent', 
                new ApiParameters(), 
                null, 
                { 
                    orderId, 
                    event 
                },
                webapiBasepath
        );
    }
}
